<div class="sidebar-container">
  <div class="sidebar-content">
    <div class="d-flex flex-column justify-content-between" style="height: 100%;">
      <div>
        <div class="logo-container" [ngClass]="{'bg-white': ('design' | env).logoWhiteBg}">
          <a class="logo-wrapper">
            <img class="logo" [src]="('design' | env).sidebarLogo">
            @if (('design' | env).logoText) {
              <div class="logo-text ml-2">{{ ('design' | env).logoText }}</div>
            }
          </a>
        </div>
        @if (addOns) {
          <ul class="sidebar-menu">
            @if (addOns.hasWorkorder) {
              <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link" routerLink="/work-orders" (click)="onSidebarLinkClicked()">
                  <img class="icon work-orders-icon" src="assets/img/work-orders-icon.svg">
                  <span class="fs-15 font-weight-500 workflow-text">{{ 'MAIN.SIDEBAR.WORK-ORDERS' | translate }}</span>
                </a>
              </li>
            }
            @if (addOns.hasTicket) {
              <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link" routerLink="/tickets" (click)="onSidebarLinkClicked()">
                  <img class="icon work-orders-icon" src="assets/img/ticket-icon.svg">
                  <span class="fs-15 font-weight-500 workflow-text">{{ 'MAIN.SIDEBAR.TICKETS' | translate }}</span>
                </a>
              </li>
            }
            @if (!noRemoteLicense) {
              <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link" routerLink="/remote-assistance" (click)="onSidebarLinkClicked()">
                  <img class="icon work-orders-icon" src="assets/img/remote-assistance.svg">
                  <span class="fs-15 font-weight-500 workflow-text">{{ 'MAIN.SIDEBAR.REMOTE-ASSISTANCE' | translate }}</span>
                </a>
              </li>
            }
            @if (!noWorkflowLicense) {
              <li class="sidebar-item" [ngClass]="{'active': workflowsActive.isActive || wReportsActive.isActive }">
                <a class="sidebar-link" routerLink="/" (click)="onSidebarLinkClicked()">
                  <img class="icon workflows-icon" src="assets/img/workflows-icon.svg">
                  <span class="fs-15 font-weight-500 workflow-text">{{ 'MAIN.SIDEBAR.WORKFLOWS' | translate }}</span>
                </a>
              </li>
            }
            <a routerLink="/" routerLinkActive [routerLinkActiveOptions]="{ exact: true }" #workflowsActive="routerLinkActive" style="display: none"></a>
            <a routerLink="/user-reports" routerLinkActive #wReportsActive="routerLinkActive" style="display: none"></a>
            @if ((isAdmin || editorAccess) && addOns.hasVideoFlow && !noWorkflowLicense) {
              <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link" routerLink="/video-flows" (click)="onSidebarLinkClicked()">
                  <img class="icon video-flows-icon" src="assets/img/video-flows-icon.svg">
                  <span class="fs-15 font-weight-600 text video-text">{{ 'MAIN.SIDEBAR.VIDEO-FLOWS' | translate }}</span>
                </a>
              </li>
            }
            @if (addOns.showNova && !noWorkflowLicense) {
              <li class="sidebar-item position-relative" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link nova-link-bg">
                  <img class="icon video-flows-icon" src="assets/img/nova.svg">
                  <span class="fs-15 font-weight-600 text video-text">Nova</span>
                </a>
                <a class="sidebar-link nova-link" routerLink="/nova" (click)="onSidebarLinkClicked()">
                  <img class="icon video-flows-icon" src="assets/img/nova.svg">
                  <span class="fs-15 font-weight-600 text video-text">Nova</span>
                </a>
              </li>
            }
            @if (isAdmin && !('electron' | env)) {
              <li class="sidebar-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <a class="sidebar-link" routerLink="/users" (click)="onSidebarLinkClicked()">
                  <img class="icon user-icon" src="assets/img/users-teams-icon.svg">
                  <span class="fs-15 font-weight-500 text user-text">{{ (noRemoteLicense ? 'MAIN.CONTENT.USER-LIST.TITLE' : 'MAIN.SIDEBAR.USERS') | translate }}</span>
                </a>
              </li>
            }
            @if (isAdmin) {
              <li class="sidebar-item" [ngClass]="{'active': workflowReportsActive.isActive || remoteSessionsActive.isActive }">
                <a class="sidebar-link" [routerLink]="noWorkflowLicense ? '/reports/remote' : '/reports/workflow'" (click)="onSidebarLinkClicked()">
                  <img class="icon report-icon" src="assets/img/reports-icon.svg">
                  <span class="fs-15 font-weight-500 text">{{ 'MAIN.SIDEBAR.REPORTS' | translate }}</span>
                </a>
              </li>
            }
            <a routerLink="/reports/workflow" routerLinkActive #workflowReportsActive="routerLinkActive" style="display: none"></a>
            <a routerLink="/reports/remote" routerLinkActive #remoteSessionsActive="routerLinkActive" style="display: none"></a>
            <!-- Analytics menu item - only for parent (master) accounts -->
            @if (isAdmin && isMaster) {
              <li class="sidebar-item" routerLinkActive="active">
                <a class="sidebar-link" routerLink="/analytics" (click)="onSidebarLinkClicked()">
                  <img class="icon analytics-icon" src="assets/img/analytics-icon.svg">
                  <span class="fs-15 font-weight-500 text">{{ 'MAIN.SIDEBAR.ANALYTICS' | translate }}</span>
                </a>
              </li>
            }
            @if (isAdmin) {
              <li class="sidebar-item" routerLinkActive="active">
                <a class="sidebar-link" routerLink="/settings" (click)="onSidebarLinkClicked()">
                  <img class="icon settings-icon" src="assets/img/settings-icon.svg">
                  <span class="fs-15 font-weight-600 text">{{ 'MAIN.SIDEBAR.SETTINGS' | translate }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </div>

      <div class="container">
        <div class="language-and-profile">
          <div class="profile-wrapper" dropdown #dropdown="bs-dropdown" [container]="'body'" [dropup]="true" placement="right bottom">
            <a id="language-toggle" class="dropdown-toggle-custom d-flex flex-row align-items-center" dropdownToggle aria-controls="language-menu">
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                  <img src="assets/img/language-icon.svg">
                  <span class="name fs-14 font-weight-500">{{ currentLang.code | uppercase }}</span>
                </div>
                <img id="dropdown-icon" src="assets/img/arrow-right-big.svg" class="ms-2" >
              </div>
            </a>
            <ul id="language-menu" *dropdownMenu class="dropdown-menu px-0 py-2" role="menu" aria-expanded="false" aria-labelledby="language-toggle">
              @for (lang of allLangs; track lang) {
                @if (currentLang !== lang) {
                  <li class="language-item" role="menuitem">
                    <a class="dropdown-item fs-14 font-weight-500" (click)="onLanguageSelected(lang)">{{ lang.code | uppercase }}</a>
                  </li>
                }
              }
            </ul>
          </div>

          <div class="profile-wrapper" dropdown #dropdown="bs-dropdown" [container]="'body'" [dropup]="true" placement="right bottom">
            <a id="profile-toggle" class="dropdown-toggle-custom d-flex flex-row align-items-center" dropdownToggle aria-controls="profile-menu">
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                  <img class="avatar" src="assets/img/newprofile-icon.svg">
                  <div class="d-flex flex-column align-items-start">
                    <span class="name fs-14 font-weight-500">{{ user.name }}</span>
                    @if (user?.auth?.account_name) {
                      <span class="name fs-12 font-weight-400">{{ user?.auth?.account_name }}</span>
                    }
                  </div>
                </div>
                <img id="dropdown-icon" src="assets/img/arrow-right-big.svg" class="ms-2" >
              </div>
            </a>
            <ul id="profile-menu" *dropdownMenu class="dropdown-menu px-0 py-2" role="menu" aria-expanded="false" aria-labelledby="profile-toggle">
              <li class="language-item" role="menuitem">
                <a class="dropdown-item fs-14 disabled" role="menuitem">v{{ version }}</a>
              </li>
              <li class="language-item" role="menuitem">
                <a class="dropdown-item fs-14" role="menuitem" (click)="onLogout()">{{ 'MAIN.NAVBAR.LOGOUT.TEXT' | translate }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>